import MappingFieldList from "./MappingFieldList";
import { getTemplateForMappingType } from "@avenueops/frontend-shared";
import { ClientMapping, ClientMappingApiType, ClientMappingField } from "@avenueops/shared-types";
import React, { useEffect, useState } from "react";

interface Props {
  selectedIntegrationId: string;
  integrationData?: any;
  clientMappingApiType: ClientMappingApiType;
  mapping: ClientMapping;
  onChange: (_: ClientMapping) => void;
  prefix: string;
  notificationPrefix?: string;
}

export default function Mapping({ integrationData, selectedIntegrationId, mapping, onChange, clientMappingApiType, prefix, notificationPrefix }: Props) {
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    // add the first render check to avoid updating the mapping when the component initially mounts
    if (!firstRender) {
      onChange(getTemplateForMappingType(clientMappingApiType));
    }
    setFirstRender(false);
  }, [clientMappingApiType]);

  return (
    <div data-prefix={`${prefix}`} className="flex flex-1">
      {mapping ? (
        <MappingFieldList
          integrationData={integrationData}
          selectedIntegrationId={selectedIntegrationId}
          fields={mapping.fields}
          update={(fields: ClientMappingField[]) => onChange({ fields })}
          mappingPrefix={""}
          clientMappingApiType={clientMappingApiType}
          isFirst={true}
          level={0}
          prefix={`${prefix}.fields`}
          notificationPrefix={notificationPrefix}
        />
      ) : null}
    </div>
  );
}
